export interface GetDefaultParameterInterLibraryLoanRequest {
  configBranchCode: string
}

export function GetDefaultParameterInterLibraryLoanRequestToJSON(
  value: GetDefaultParameterInterLibraryLoanRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined
  }
}
